import React from "react";

import classNames from "classnames";
import { addDays, subDays } from "date-fns";
import { Button, Col, Row } from "react-bootstrap";
import ReactDatePicker from "react-datepicker";
import Select from "react-select";

import { useFiltersContext } from "../contexts/Filters";
import { isXOrBigger, isXOrSmaller } from "../../../../lib/utils";
import useBreakpoint from "../../../../hooks/useBreakpoint";

const Filters = React.memo(() => {
    const { filters, setFilters } = useFiltersContext();
    const breakpoint = useBreakpoint();

    return (
        <>
            <Row className={classNames("gameFilters")}>
                <Col
                    xs={12}
                    xl={4}
                    className={classNames({
                        "mb-3": isXOrSmaller("lg", breakpoint),
                    })}
                >
                    <h6>Date:</h6>
                    <ReactDatePicker
                        className={classNames({
                            "form-control": true,
                        })}
                        selected={
                            filters.dateStart
                                ? new Date(filters.dateStart)
                                : undefined
                        }
                        onChange={d =>
                            setFilters(prev => ({
                                ...prev,
                                dateStart: d || undefined,
                            }))
                        }
                        maxDate={
                            filters.dateEnd
                                ? subDays(new Date(filters.dateEnd), 1)
                                : undefined
                        }
                        showIcon
                        isClearable
                        showMonthDropdown
                        showYearDropdown
                        dateFormat="MM/dd/yyyy"
                        dropdownMode="select"
                        toggleCalendarOnIconClick
                        placeholderText="mm/dd/yyyy"
                        enableTabLoop={false}
                    />
                    <b>{` to `}</b>
                    <ReactDatePicker
                        className={classNames({
                            "form-control": true,
                        })}
                        showIcon
                        selected={
                            filters.dateEnd
                                ? new Date(filters.dateEnd)
                                : undefined
                        }
                        onChange={d =>
                            setFilters(prev => ({
                                ...prev,
                                dateEnd: d || undefined,
                            }))
                        }
                        minDate={
                            filters.dateStart
                                ? addDays(new Date(filters.dateStart), 1)
                                : undefined
                        }
                        isClearable
                        showMonthDropdown
                        showYearDropdown
                        dateFormat="MM/dd/yyyy"
                        dropdownMode="select"
                        toggleCalendarOnIconClick
                        placeholderText="mm/dd/yyyy"
                        enableTabLoop={false}
                    />
                </Col>
                <Col
                    xs={12}
                    sm={6}
                    lg={3}
                    xl={2}
                    className={classNames({
                        "mb-3": isXOrSmaller("md", breakpoint),
                    })}
                >
                    <h6>League Name:</h6>
                    <Select
                        isSearchable={true}
                        isClearable={true}
                        isMulti={true}
                        options={filters.leagueName.options.map(l => {
                            return {
                                value: l,
                                label: l,
                            };
                        })}
                        value={
                            filters.leagueName.filter?.length
                                ? filters.leagueName.filter?.map(l => {
                                      return {
                                          value: l,
                                          label: l,
                                      };
                                  })
                                : null
                        }
                        onChange={l => {
                            setFilters(prev => ({
                                ...prev,
                                leagueName: {
                                    ...prev.leagueName,
                                    filter:
                                        l.length === 0
                                            ? undefined
                                            : l?.map(o => o.label),
                                },
                            }));
                        }}
                    />
                </Col>
                <Col
                    xs={12}
                    sm={6}
                    lg={3}
                    xl={2}
                    className={classNames({
                        "mb-3": isXOrSmaller("md", breakpoint),
                    })}
                >
                    <h6>Age:</h6>
                    <Select
                        isSearchable={false}
                        isClearable={true}
                        isMulti={true}
                        options={filters.ageLevels.options.map(a => {
                            return {
                                value: a,
                                label: a,
                            };
                        })}
                        value={
                            filters.ageLevels.filter?.length
                                ? filters.ageLevels.filter?.map(a => {
                                      return {
                                          value: a,
                                          label: a,
                                      };
                                  })
                                : null
                        }
                        onChange={a => {
                            setFilters(prev => ({
                                ...prev,
                                ageLevels: {
                                    ...prev.ageLevels,
                                    filter:
                                        a.length === 0
                                            ? undefined
                                            : a?.map(o => o.label),
                                },
                            }));
                        }}
                    />
                </Col>
                <Col
                    xs={12}
                    sm={6}
                    lg={7}
                    xl={2}
                    className={classNames({
                        "mb-3": isXOrSmaller("md", breakpoint),
                    })}
                >
                    <h6>Location:</h6>
                    <Select
                        isSearchable={true}
                        isClearable={true}
                        isMulti={true}
                        options={filters.location.options.map(l => {
                            return {
                                value: l,
                                label: l,
                            };
                        })}
                        value={
                            filters.location.filter?.length
                                ? filters.location.filter?.map(l => {
                                      return {
                                          value: l,
                                          label: l,
                                      };
                                  })
                                : null
                        }
                        onChange={l => {
                            setFilters(prev => ({
                                ...prev,
                                location: {
                                    ...prev.location,
                                    filter:
                                        l.length === 0
                                            ? undefined
                                            : l?.map(o => o.label),
                                },
                            }));
                        }}
                    />
                </Col>
                <Col
                    className={classNames({
                        filterButtons: true,
                        "justify-content-end": isXOrBigger("lg", breakpoint),
                        "justify-content-start": isXOrSmaller("md", breakpoint),
                        "alignt-content-end": true,
                        "d-flex": true,
                        "flex-wrap": true,
                    })}
                    xs={12}
                    lg={2}
                >
                    <Button
                        className={classNames({
                            clearFilters: true,
                            "align-self-end": true,
                        })}
                        onClick={() =>
                            setFilters({
                                ageLevels: {
                                    ...filters.ageLevels,
                                    filter: undefined,
                                },
                                dateStart: undefined,
                                dateEnd: undefined,
                                location: {
                                    ...filters.location,
                                    filter: undefined,
                                },
                                leagueName: {
                                    ...filters.leagueName,
                                    filter: undefined,
                                },
                                openings: true,
                            })
                        }
                    >
                        Clear Filters
                    </Button>
                    <Button
                        className={classNames({ "align-self-end": true })}
                        onClick={() =>
                            setFilters(prev => ({
                                ...prev,
                                openings: !prev.openings,
                            }))
                        }
                    >
                        Show {filters.openings ? "All" : "Openings"}
                    </Button>
                </Col>
            </Row>
        </>
    );
});

export default Filters;
